// extracted by mini-css-extract-plugin
export default {"MainContainer":"HelloView_MainContainer__OQ5C5","ContentSection":"HelloView_ContentSection__x1E8i","Container_Waves":"HelloView_Container_Waves__R7brO"};